import { IPartialTheme, IStyleSet } from "@fluentui/react/lib/Styling"
import { IStyleFunctionOrObject } from "@fluentui/react/lib/Utilities"

import { IHeaderStyles } from "./Header.types"

export const HeaderStyles: IStyleFunctionOrObject<
    IPartialTheme,
    IStyleSet<IHeaderStyles>
> = (theme: IPartialTheme) => ({
    root: {
        display: "flex",
        flexGrow: 1
    },

    header: {
        display: "flex",
        flexGrow: 1,
        padding: "1em",
        minWidth: 0,
        borderBottom: `1px solid ${theme.palette?.neutralTertiaryAlt}`
    },

    west: {
        flexGrow: 0,
        // product image size
        minWidth: "3rem",
        // expand only to content size
        flexBasis: "max-content",
        // unless it gets larger than 20rem. then overflow
        maxWidth: "16rem"
    },

    center: {
        flex: 1,
        minWidth: 0,
        overflow: "hidden",
        justifyContent: "space-between"
    },

    east: {}
})
